import { Check } from "lucide-react";
import { SERVICES } from "@/data/content";
import { Reveal } from "./Reveal";

export default function Services() {
  return (
    <section id="services" className="py-24 md:py-32 px-6 md:px-10 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="max-w-2xl">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Nos services</span>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl font-normal tracking-tight text-forest leading-[1.1]">
              Un accompagnement complet, pensé pour vous
            </h2>
          </div>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={i * 0.08} className={s.large ? "lg:col-span-3 lg:row-auto" : ""}>
                <div
                  className={`group h-full bg-cream/60 border border-forest/5 rounded-3xl p-8 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_24px_48px_-24px_rgba(48,66,56,0.3)] hover:bg-white ${s.large ? "lg:flex lg:items-start lg:gap-10" : ""}`}
                  data-testid={`service-card-${i}`}
                >
                  <div className={s.large ? "lg:w-1/3" : ""}>
                    <div className="w-14 h-14 rounded-2xl bg-sage/12 flex items-center justify-center mb-5 transition-colors group-hover:bg-sage/20">
                      <Icon className="w-7 h-7 text-sage" strokeWidth={1.5} />
                    </div>
                    <h3 className="font-cormorant text-2xl md:text-3xl font-medium text-forest">{s.title}</h3>
                    <p className="mt-2 text-sm text-forest/60 leading-relaxed">{s.desc}</p>
                  </div>
                  <ul className={`mt-6 ${s.large ? "lg:mt-0 lg:flex-1 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3" : "space-y-3"}`}>
                    {s.items.map((it) => (
                      <li key={it} className="flex items-center gap-3 text-sm text-forest/80">
                        <span className="w-5 h-5 rounded-full bg-gold/15 flex items-center justify-center shrink-0">
                          <Check className="w-3 h-3 text-gold" strokeWidth={2.5} />
                        </span>
                        {it}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
